import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DynamicHttpTableComponent } from '@components/ng-dynamic-http-table';
import { debounceTime } from 'rxjs/operators';
import { Grant } from 'src/models/grant';

import { MainTitle } from '../../models/main-title';
import { GrantService } from '../../services/grant.service';
import { parseDateFromDatePicker } from '../../utils/shared-functions';
import { ConfirmComponent } from '../confirm/confirm.component';
import { CreateGrantComponent } from './create-grant/create-grant.component';

@Component({
  selector: 'app-grant-management',
  templateUrl: './grant-management.component.html',
  styleUrls: ['./grant-management.component.scss']
})
export class GrantManagementComponent implements OnInit {
  public title = new MainTitle('GrantManagementComponent.title');
  /**
   * Child table component
   */
  @ViewChild('grantTable', { static: false }) grantTable?: DynamicHttpTableComponent;

  actionMapping = {
    info: (grant: Grant): void => this.openCreateGrantDialog(grant),
    delete: (grant: Grant): void => this.deleteGrant(grant)
  };

  searchInput: FormGroup;
  myColumns = {
    name: { label: 'Nombre', type: 'text' },
    percentage: { label: 'Descuento %', filter: (percentage: number): string => percentage.toString() + ' %',
      type: 'text' },
    startDate: { label: 'Desde', filter: (date: Date): string => parseDateFromDatePicker(date), type: 'text' },
    endDate: { label: 'Hasta', filter: (date: Date): string => parseDateFromDatePicker(date), type: 'text' },
    menu: {
      label: '',
      type: 'menu-button',
      elements: [
        {
          label: 'Editar beca',
          method: (el: Grant): void => this.actionMapping['info'](el)
        },
        {
          label: 'Borrar beca',
          method: (el: Grant): void => this.actionMapping['delete'](el)
        }
      ],
      class: 'fa-solid fa-ellipsis-vertical',
      buttonClass: 'btn-charges'
    }
  };

  constructor(
    public grantService: GrantService,
    private builder: FormBuilder,
    public dialogService: MatDialog
  ) {
    this.searchInput = this.builder.group({
      searchText: ''
    });
  }

  ngOnInit(): void {
    this.searchInput.valueChanges.pipe(debounceTime(400)).subscribe(() => this.search());
  }

  /**
   * Method to search by query and reload the table
   */
  search(): void {
    this.grantTable?.applyFilter(this.searchInput.get('searchText')?.value);
  }

  openCreateGrantDialog(grant?: Grant): void {
    const createGrantData: any = {
      width: '538px',
    }
    if (grant) {
      createGrantData['data'] = { 'grant': grant }
    }

    const createGrantDialog = this.dialogService.open(CreateGrantComponent, createGrantData);
    createGrantDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.grantTable?.getResults();
      }
    });
  }

  /**
   * Method to delete the grant
   * @param grant
   */
  deleteGrant(grant: Grant): void {
    const delDialogRef = this.dialogService.open(ConfirmComponent, {
      width: '400px',
      data: {
        acceptDialog: 'Eliminar beca',
        title: 'Eliminar beca',
        message: '¿Estás seguro de que quieres borrar la beca?',
        destructive: true
      }
    });

    delDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.grantService.delete(grant._id).subscribe(() => {
          this.grantTable?.getResults();
        });
      }
    });
  }
}
